import { Drawer, useMediaQuery, useTheme } from "@mui/material";
import LensIcon from "@mui/icons-material/Flare";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/ExitToApp";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import SidebarNav, { PageItem } from "./components/SidebarNav";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import { Logo, SupermanIcon } from "components/Icons";
import { useAppSelector } from "redux/hooks";
import { selectIsSupport, selectUserInfo } from "redux/slices/session";
import { Science } from "@mui/icons-material";
import { HelpIconOutlined } from "components/CustomIcons";
import { cn } from "components/lib/utils";

const Sidebar = () => {
  const theme = useTheme();
  const userInfo = useAppSelector(selectUserInfo);
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  const anchor = isMobile ? "bottom" : "left";
  const supportPages = useAppSelector(selectIsSupport)
    ? [
        {
          title: "Support",
          route: "/dashboard",
          icon: <SupermanIcon />,
          canBeActive: true,
        },
        {
          title: "Lens Editor",
          route: "/lens-editor",
          icon: <Science />,
          canBeActive: true,
        },
      ]
    : null;

  const topPages: PageItem[] = [
    {
      title: "Pattern",
      icon: <Logo size={24} />,
      route: "/lens",
      canBeActive: false,
    },
    {
      title: "Lenses",
      route: "/lens",
      icon: <LensIcon />,
      canBeActive: true,
    },
    {
      title: "Import",
      route: "/import",
      icon: <CloudUploadIcon />,
      canBeActive: true,
    },
    {
      title: "Users",
      route: "/users",
      icon: <PeopleIcon />,
      canBeActive: true,
    },
  ];

  if (supportPages && !isMobile) {
    topPages.push(...supportPages);
  }

  const bottomPages: PageItem[] = [
    {
      title: "Help",
      route: undefined,
      icon: <HelpIconOutlined />,
      canBeActive: false,
    },
    {
      title: "Resource Center",
      route: undefined,
      icon: <ImportContactsIcon />,
      canBeActive: false,
    },
    {
      title: `Log Out - ${userInfo?.email}`,
      route: "/logout",
      icon: <LogoutIcon />,
      canBeActive: false,
    },
  ];

  if (isMobile) {
    topPages.splice(
      topPages.findIndex((p) => p.title === "Import"),
      1
    );
    bottomPages.splice(0, 1);
  }

  return (
    <Drawer
      variant="permanent"
      anchor={anchor}
      sx={{
        width: 64,
        gridArea: "sidenav",
        [theme.breakpoints.only("xs")]: {
          width: "100%",
          height: "49px",
        },
      }}>
      <div className={cn("flex h-full", isMobile ? "flex-row" : "flex-col")}>
        <SidebarNav topPages={topPages} bottomPages={bottomPages} />
      </div>
    </Drawer>
  );
};

export default Sidebar;
